// src/components/SettingsDrawer.jsx
import { useEffect, useState } from "react";

const get = (k, d) => localStorage.getItem(k) ?? d;
const set = (k, v) => localStorage.setItem(k, v);

export default function SettingsDrawer({ open, onClose }) {
  const [theme, setTheme] = useState(get("pw_theme", "system"));
  const [compact, setCompact] = useState(get("pw_compact", "0") === "1");
  const [sport, setSport] = useState(get("pw_default_sport", "MLB"));
  const [restoreFilters, setRestoreFilters] = useState(get("pw_restore_filters", "1") === "1");
  const [odds, setOdds] = useState(get("pw_odds_format", "american"));
  const [tz, setTz] = useState(get("pw_tz", "local"));
  const [tooltips, setTooltips] = useState(get("pw_tooltips", "1") === "1");

  useEffect(() => {
    if (!open) return;
    setTheme(get("pw_theme", "system"));
    setCompact(get("pw_compact", "0") === "1");
    setSport(get("pw_default_sport", "MLB"));
    setRestoreFilters(get("pw_restore_filters", "1") === "1");
    setOdds(get("pw_odds_format", "american"));
    setTz(get("pw_tz", "local"));
    setTooltips(get("pw_tooltips", "1") === "1");
  }, [open]);

  const save = () => {
    set("pw_theme", theme);
    set("pw_compact", compact ? "1" : "0");
    set("pw_default_sport", sport);
    set("pw_restore_filters", restoreFilters ? "1" : "0");
    set("pw_odds_format", odds);
    set("pw_tz", tz);
    set("pw_tooltips", tooltips ? "1" : "0");
    window.dispatchEvent(new Event("pw:settings-changed"));
    onClose?.();
  };

  const resetAll = () => {
    Object.keys(localStorage)
      .filter(k => k.startsWith("pw_"))
      .forEach(k => localStorage.removeItem(k));
    window.dispatchEvent(new Event("pw:settings-changed"));
    onClose?.();
  };

  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,.35)",
        display: "grid", placeItems: "center", zIndex: 1000
      }}
      onClick={onClose}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          width: 520, maxWidth: "95vw", background: "#fff",
          borderRadius: 12, padding: 20, boxShadow: "0 24px 60px rgba(0,0,0,.2)"
        }}
      >
        <h2 style={{ margin: 0, marginBottom: 6 }}>App Settings</h2>
        <p style={{ marginTop: 0, opacity: .7, fontSize: 13 }}>
          Your preferences are saved to this device.
        </p>

        <div style={{ display: "grid", gap: 14, marginTop: 10 }}>
          <label>Theme
            <select value={theme} onChange={e=>setTheme(e.target.value)} style={{ width:"100%" }}>
              <option value="system">System</option>
              <option value="light">Light</option>
              <option value="dark">Dark</option>
            </select>
          </label>

          <label style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <input type="checkbox" checked={compact} onChange={e=>setCompact(e.target.checked)} />
            Compact cards
          </label>

          <label>Default sport
            <select value={sport} onChange={e=>setSport(e.target.value)} style={{ width:"100%" }}>
              {["MLB","NBA","WNBA","NFL","SOCCER","MMA","CFB"].map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </label>

          <label style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <input type="checkbox" checked={restoreFilters} onChange={e=>setRestoreFilters(e.target.checked)} />
            Reuse last filters on open
          </label>

          <label>Odds format
            <select value={odds} onChange={e=>setOdds(e.target.value)} style={{ width:"100%" }}>
              <option value="american">American</option>
              <option value="decimal">Decimal</option>
            </select>
          </label>

          <label>Time zone
            <select value={tz} onChange={e=>setTz(e.target.value)} style={{ width:"100%" }}>
              <option value="local">Local</option>
              <option value="ET">ET</option>
              <option value="UTC">UTC</option>
            </select>
          </label>

          <label style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <input type="checkbox" checked={tooltips} onChange={e=>setTooltips(e.target.checked)} />
            Show tooltips & explanations
          </label>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 18 }}>
          <button onClick={resetAll} className="btn-secondary">Reset</button>
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={onClose} className="btn-secondary">Cancel</button>
            <button onClick={save} className="btn-primary">Save</button>
          </div>
        </div>
      </div>
    </div>
  );
}
